export default function SITE_VERSION() {
    return "09.02.2024; v.2.7.2";
}